import {PatientExtended} from '@/features/patients/types'
import {CreateProjectFormValidationSchema} from '@/features/projects/formSchemas'
import {zodResolver} from '@hookform/resolvers/zod'
import {ReactNode} from 'react'
import {FormProvider, useForm} from 'react-hook-form'

export const CreateProjectFormProvider = ({
    children,
    defaultPatient
}: {
    children: ReactNode
    defaultPatient?: PatientExtended
}) => {
    const form = useForm<CreateProjectFormValidationSchema>({
        mode: 'onBlur',
        resolver: zodResolver(CreateProjectFormValidationSchema),
        defaultValues: {
            patient: defaultPatient
                ? {
                      id: defaultPatient.id,
                      fullName: defaultPatient.fullName,
                      serviceType: defaultPatient.serviceType
                  }
                : undefined,
            sector: defaultPatient?.treatmentRequest?.sector,
            treatmentRequestId: defaultPatient?.treatmentRequest?.id
            // projectType: isCycleResumption ? 'cyclic' : isTreatmentResumption ? 'continuous' : undefined,
            // numberOfCycles: isCycleResumption ? lastProject?.numberOfCycles ?? undefined : undefined,
            // durationDays: lastProject?.durationDays ?? undefined,
            // sender: defaultSender ?? undefined,
            // specialist: defaultSpecialist ?? undefined
        }
    })

    return <FormProvider {...form}>{children}</FormProvider>
}
